import { createRoot } from 'react-dom/client'
import './index.css'
import CTASection from './App.jsx'

// Wait for DOM to be ready and check if container exists
function initCTASection() {
  const container = document.getElementById('cta-root');
  if (container) {
    const root = createRoot(container);
    root.render(<CTASection />);
  } else {
    console.warn('CTA section container #cta-root not found');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCTASection);
} else {
  initCTASection();
}